// extracted by mini-css-extract-plugin
export var bodySections = "_cp-8";
export var gray = "_cp-7";
export var green = "_cp-4";
export var iconContainer = "_cp-9";
export var iconWidgetContainer = "_cp-1";
export var phoneIcon = "_cp-2";
export var red = "_cp-5";
export var statusDot = "_cp-3";
export var widgetContainer = "_cp-0";
export var yellow = "_cp-6";